module.exports = __webpack_public_path__ + "static/media/MATIC-USDC.cfa9f6d0.png";